<template>
        <div id="dispute-response-modal" class="modal fade" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Authorization Dispute Response</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>Please indicate the OWCA's response to the dispute for medical treatment (Form 1009).</p>
                    </div>
                    <div class="modal-footer text-center">
                        <button type="button" class="btn btn-sm btn-success" @click="update(DocumentStatus.AUTHORIZATION_DISPUTE_APPROVED)" data-dismiss="modal">
                            <i class="fas fa-thumbs-up fa-lg"></i>
                            Approved
                        </button>
                        <button type="button" class="btn btn-sm btn-danger" @click="update(DocumentStatus.AUTHORIZATION_DISPUTE_DENIED)" data-dismiss="modal">
                            <i class="fas fa-thumbs-down fa-lg"></i>
                            Denied
                        </button>
                        <!-- <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">
                            <i class="far fa-lg fa-question-circle text-muted"></i>
                            No Response
                        </button> -->
                    </div>
                </div>
            </div>
        </div>                        
</template>

<script>
import { DocumentStatus } from '../../constants.js';

export default {
    data() {
        return {
            documentId: null,

            // import constants into the template
            DocumentStatus: DocumentStatus,            
        }
    },
    methods: {
        show: function (id) {
            this.documentId = id;
            $('#dispute-response-modal').modal('show');
        },
        update: function (statusId) {
            axios.patch('/ajax/documents/' + this.documentId + '/status', {
                'document_status_id': statusId
            })
            .then(response => {

            })
            .catch(error => {
                let title = error.response.data.title;
                let message = error.response.data.message;
                let level = error.response.data.level;
                toastr[level](message, title, {timeOut: 10000, positionClass: "toast-top-full-width", closeButton: true});
            });            
        }
    },
    created() {
        eventHub.$on('show-dispute-response', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-dispute-response');
    },      
}
</script>

<style scoped>

</style>